module.exports = __webpack_public_path__ + "img/anti_potter_badge.950f7c1c.jpg";